import React from "react";

import { ComponentLayout } from "../../support/ComponentLayout";
import { ComponentSectionLayout } from "../../support/ComponentSectionLayout";

export const FormCheckboxesDemo: React.FC<unknown> = () => {
  return (
    <ComponentLayout title={"Wip - Form Checkboxes"}>
      <ComponentSectionLayout title={"default"}></ComponentSectionLayout>
    </ComponentLayout>
  );
};
